'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

var _FormValidationService = require('./../../../common/services/FormValidationService');

var _FormValidationService2 = _interopRequireDefault(_FormValidationService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VehicleAppraisalController = function () {
  function VehicleAppraisalController(authService, $state, enums, vehicleService, loadingService, $stateParams, $scope, printService, lookupService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, VehicleAppraisalController);
    this.authService = authService;
    this.$state = $state;
    this.enums = enums;
    this.vehicleService = vehicleService;
    this.loadingService = loadingService;
    this.$stateParams = $stateParams;
    this.$scope = $scope;
    this.printService = printService;
    this.lookupService = lookupService;

    this.formValidationService = new _FormValidationService2.default();

    if (!authService.validateUser(false, 'Vehicle', enums.PERMISSION_TYPE.Add, true)) {
      return;
    }

    this.panels = {
      'basicDetails': true
    };

    this.state = '';
    this.settlement = this.$stateParams.settlement;

    this.vehicleAppraisal = {
      imageUrl: '/images/appraisal.png',
      imageBase: null,
      vehicleTraderId: null,
      financeCompanyId: null,
      appearance: null,
      roadTest: null
    };
    this.resetVehicle();

    this.origin = $stateParams.origin;

    this.loadVehicleAppraisal();
  }

  (0, _createClass3.default)(VehicleAppraisalController, [{
    key: 'resetVehicle',
    value: function resetVehicle(autoSold) {
      var reg = void 0;

      if (this.vehicleAppraisal.vehicle) {
        reg = this.vehicleAppraisal.vehicle.registration;
      }

      this.vehicleAppraisal.vehicle = {
        registration: reg,
        entityId: this.authService.authData.currentLocation.key,
        vehicleCondition: this.enums.VEHICLE_CONDITION.Used,
        autoSold: autoSold || null,
        mediaItems: [],
        brandModelId: null
      };

      this.configureForm();
    }
  }, {
    key: 'configureForm',
    value: function configureForm() {
      var ctrl = this;

      ctrl.formValidationService.initialize(ctrl.vehicleAppraisal);

      ctrl.formValidationService.addField({
        fieldName: 'autoSold',
        displayName: 'Trade / Retail',
        model: ctrl.vehicleAppraisal.vehicle,
        type: 'select',
        required: true
      });

      ctrl.formValidationService.addField({
        fieldName: 'registration',
        displayName: 'Registration',
        model: ctrl.vehicleAppraisal.vehicle,
        type: 'text',
        required: true
      });

      if (this.$state.current.name === 'vehicleTradeIn') {
        ctrl.formValidationService.addField({
          fieldName: 'mileage',
          displayName: 'Mileage',
          model: ctrl.vehicleAppraisal.vehicle,
          type: 'int',
          required: true
        });
      }

      ctrl.formValidationService.addField({
        fieldName: 'brandModelId',
        displayName: 'Model',
        model: ctrl.vehicleAppraisal.vehicle,
        required: true
      });

      this.$scope.$broadcast('vehicleAppraisal:parentFormConfigured');
    }
  }, {
    key: 'editVehicle',
    value: function editVehicle(print) {
      var _this = this;

      var ctrl = this;

      if (!ctrl.formValidationService.validateForm() || !this.allowanceCheck()) {
        return;
      }

      this.state = 'Saving';

      ctrl.loadingService.showLoading('editVehicle', 'Saving Changes ...');

      //massage data
      if (typeof ctrl.vehicleAppraisal.vehicle.brandModel === 'string') {
        ctrl.vehicleAppraisal.vehicle.brandModel = null;
      }

      if (!ctrl.vehicleAppraisal.allowance) {
        ctrl.vehicleAppraisal.allowance = 0;
      }

      ctrl.vehicleService.editVehicleAppraisal(ctrl.$stateParams.contactId, ctrl.$stateParams.enquiryId, ctrl.vehicleAppraisal).then(function (response) {
        _this.state = 'Saved';

        if (print) {
          ctrl.printService.printVehicleAppraisal(ctrl.vehicleAppraisal.vehicleAppraisalId, ctrl.$stateParams.enquiryId);
        }

        ctrl.redirectToParent(response.data);
      }).catch(function (err) {
        if (err.status === 400) {
          //Bad Request
          ctrl.state = 'ModelError';

          err.data.map(function (item) {
            ctrl.formValidationService.addModelError(item.key.substring(item.key.indexOf('.') + 1).toCamelCase(), item.value);
          });
        } else if (err.status === 500) {
          ctrl.state = 'SystemError';
          ctrl.formValidationService.addSystemError(null, "A system error occurred while processing your request. Please try again later or contact system administrator if problem persists.");
        }
      }).finally(function () {
        ctrl.loadingService.hideLoading('editVehicle');
      });
    }
  }, {
    key: 'allowanceCheck',
    value: function allowanceCheck() {
      if (this.vehicleAppraisal.overAllowance && this.vehicleAppraisal.overAllowance > this.vehicleAppraisal.allowance) {
        this.formValidationService.addModelError('allowance', 'Overallowance cannot be greater than allowance');
        return false;
      }

      return true;
    }
  }, {
    key: 'redirectToParent',
    value: function redirectToParent(vehicleId) {
      if (this.origin.source) {
        var output = this.origin.processResult(vehicleId, this.vehicleAppraisal, this.settlement);
        this.$state.go(output.stateName, output.params);
      } else {
        this.$state.go('vehicleList');
      }
    }
  }, {
    key: 'loadVehicleAppraisal',
    value: function loadVehicleAppraisal() {
      var _this2 = this;

      var ctrl = this;

      if (ctrl.$stateParams.vehicleId) {
        ctrl.loadingService.showLoading('vehicleInfo', 'Loading Vehicle ...');

        ctrl.vehicleService.getVehicleAppraisal(ctrl.authService.authData.currentLocation.key, ctrl.$stateParams.vehicleId, ctrl.$stateParams.enquiryId).then(function (response) {
          (0, _assign2.default)(ctrl.vehicleAppraisal, response.data);

          _this2.loadExtras();

          _this2.configureForm();

          _this2.showMazdaServiceHistory();
        }).catch(function (err) {}).finally(function () {
          ctrl.loadingService.hideLoading('vehicleInfo');
        });
      } else {
        this.configureForm();
      }
    }
  }, {
    key: 'loadExtras',
    value: function loadExtras() {
      var ctrl = this;

      var nctExpiry = (0, _lodash.find)(ctrl.vehicleAppraisal.vehicle.extras, function (o) {
        return o.key === 'NCT Expiry Date';
      });
      var taxExpiry = (0, _lodash.find)(ctrl.vehicleAppraisal.vehicle.extras, function (o) {
        return o.key === 'Tax Expiry Date';
      });
      var prevOwners = (0, _lodash.find)(ctrl.vehicleAppraisal.vehicle.extras, function (o) {
        return o.key === 'Previous Owners';
      });

      if (nctExpiry) {
        ctrl.vehicleAppraisal.vehicle.nctExpiry = nctExpiry.value;
      }

      if (taxExpiry) {
        ctrl.vehicleAppraisal.vehicle.taxExpiry = taxExpiry.value;
      }

      if (prevOwners) {
        ctrl.vehicleAppraisal.vehicle.prevOwners = prevOwners.value;
      }
    }
  }, {
    key: 'showMazdaServiceHistory',
    value: function showMazdaServiceHistory() {
      var _this3 = this;

      this.lookupService.lookupBrands().then(function (brands) {
        var mazdaBrand = (0, _lodash.find)(brands, function (b) {
          return b.name.toLowerCase() === 'mazda';
        });

        _this3.$scope.$broadcast('vehicleEdit:lookupVehicleSelected', { chassisNo: _this3.vehicleAppraisal.vehicle.chassisNo, isMazda: _this3.vehicleAppraisal.vehicle.brandId == mazdaBrand.brandId });
      });
    }
  }]);
  return VehicleAppraisalController;
}();

exports.default = VehicleAppraisalController;


// WEBPACK FOOTER //
// ./client/app/components/vehicle/vehicleAppraisal/vehicleAppraisal.controller.js